import { iModalsState, tModalName } from "../../interfaces/interfaces";
import { eModalsActionTypes, tModalsAction } from "./modalsTypes";

const initialState: iModalsState = {
	modalsIds: {
		deposit: 0,
		withdraw: 0,
		info: 0,
		confirm: 0,
		transaction: 0,
		wallet: 0,
		pairSelect: 0,
		mobileMenu: 0,
	},
	openedModals: [],
};

export const modalsReducer = ( state = initialState, action: tModalsAction) : iModalsState => {
	switch (action.type){
	
		case eModalsActionTypes.CLEAR_STATE:
			return initialState;

		case eModalsActionTypes.OPEN_NEW_MODAL:
			// let modalsIdsCopy = structuredClone(state.modalsIds);    // JS should be updated
			let modalsIds: {[K in tModalName]: number} = Object.assign(state.modalsIds);
			modalsIds[action.payload.modalName] = state.modalsIds[action.payload.modalName] + 1;
			return {
				...state,
				openedModals: state.openedModals.concat({...action.payload, modalId: state.modalsIds[action.payload.modalName]}),
				modalsIds,
			};

		case eModalsActionTypes.CLOSE_MODAL:
			return {
				...state,
				openedModals: state.openedModals.filter(modal =>
					!(modal.modalName === action.payload.name &&
					modal.modalId === action.payload.id)
				)
			};
		
		default: return state;
	}
};